import React from 'react';

interface DividerProps {
  orientation?: 'horizontal' | 'vertical';
  thickness?: string;
  colorClass?: string;
  className?: string;
}

const Divider: React.FC<DividerProps> = ({
  orientation = 'horizontal',
  thickness = '1',
  colorClass = 'bg-gray-300',
  className = 'h-[1px] w-full opacity-30',
}) => {
  const baseClasses = `${colorClass} ${className}`;

  if (orientation === 'vertical') {
    // vertical line: width = thickness, full height
    return <div className={`w-${thickness} h-full ${baseClasses}`} />;
  }

  // horizontal line: height = thickness, full width
  return <div className={`h-${thickness} w-full ${baseClasses}`} />;
};

export default Divider;
